export default __webpack_public_path__ + "partner_7dcf72d.png";